import { FeatureAnalysisSkeleton } from "@pages/platform-analysis-v2/_id/components/skeletons/feature-analysis";

export const BusinessMetricAnalysisSkeleton = FeatureAnalysisSkeleton;
